import { EntityType, AttachmentComponent, useParams } from "../../utils/globalImports";


interface ProposalAttachmentProps {
  
}

const ProposalAttachment: React.FC<ProposalAttachmentProps> = ({}) => {
  const { proposalId } = useParams<{ proposalId: string }>();
  return (
     <AttachmentComponent
        entityTypeId={EntityType.Proposal}
        entityId={Number(proposalId)}
        resourceId={Number(proposalId)}
        title="Proposal Attachments"
        searchbarText="Search for attachments"
      />
  );
};

export default ProposalAttachment;